import React from 'react'
import Typer from 'react-typed'

function Header() {
    return (
        <div className="header-wraper" >
            <div className="main-info" ><br/><br/>
            <small style={{color: "red"}}>&lt;h1&gt;</small><h1>Web dev and web promotion </h1><small style={{color: "red"}}>&lt;/h1&gt;</small> 
                <Typer 
                    className="typed-text"
                    strings={["FullStack Web Dev", "Web Design", "Web Dev", "Game Dev", "Mobile App Dev", "DeskTop App Dev"]}
                    typeSpeed={50}
                    backSpeed={60}
                    loop
                />  
                <a href="index.html#contact" className="btn-main-offer">Contact Me</a>
                <div className="slider-container">
                    <div className="menu">
                        <label for="slide-dot-0"></label>
                        <label for="slide-dot-1"></label>
                        <label for="slide-dot-2"></label>
                        <label for="slide-dot-3"></label>
                        <label for="slide-dot-4"></label>
                        <label for="slide-dot-5"></label>
                        <label for="slide-dot-6"></label>
                        <label for="slide-dot-7"></label>
                        <label for="slide-dot-8"></label>
                        <label for="slide-dot-9"></label>                                                
                    </div>
                    
                    <input id="slide-dot-0" type="radio" name="slides"/>
                        <div className="slide slide-0"></div>
                    
                    <input id="slide-dot-1" type="radio" name="slides"/>
                        <div className="slide slide-1"></div>
                    
                    <input id="slide-dot-2" type="radio" name="slides"/>
                        <div className="slide slide-2"></div>
                    
                    <input id="slide-dot-3" type="radio" name="slides"/>
                        <div className="slide slide-3"></div>
                    
                    <input id="slide-dot-4" type="radio" name="slides"/>
                        <div className="slide slide-4"></div>
                    
                    <input id="slide-dot-5" type="radio" name="slides"/>
                        <div className="slide slide-5"></div>
                    
                    <input id="slide-dot-6" type="radio" name="slides" checked />
                        <div className="slide slide-6"></div>
                    
                    <input id="slide-dot-7" type="radio" name="slides"/>
                        <div className="slide slide-7"></div>
                    
                    <input id="slide-dot-8" type="radio" name="slides"/>
                        <div className="slide slide-8"></div>
                  
                    <input id="slide-dot-9" type="radio" name="slides"/>
                        <div className="slide slide-9"></div>                        
                </div>


            </div>
        </div>
    )
}

export default Header
